import Auth from '@/helpers/authorizations'
import Management from '@/layouts/Management'

export default {
  path: '/chargers',
  component: Management,
  redirect: '/chargers/list',
  children: [
    // 列表页
    {
      path: 'list',
      component: () => import('@/views/chargers/List'),
      redirect: 'list/all',
      meta: {
        auth: Auth.listChargers
      },
      children: [
        {
          path: 'all',
          component: () => import('@/views/chargers/ListTable'),
          meta: {
            auth: Auth.listChargers,
            tabName: 'all'
          }
        },
        {
          path: 'public_dc',
          component: () => import('@/views/chargers/ListTable'),
          meta: {
            auth: Auth.listChargers,
            tabName: 'public_dc'
          }
        },
        {
          path: 'public_ac',
          component: () => import('@/views/chargers/ListTable'),
          meta: {
            auth: Auth.listChargers,
            tabName: 'public_ac'
          }
        },
        {
          path: 'public_alarm',
          component: () => import('@/views/chargers/ListTable'),
          meta: {
            auth: Auth.listChargers,
            tabName: 'public_alarm'
          }
        },
        {
          path: 'private',
          component: () => import('@/views/chargers/ListTable'),
          meta: {
            auth: Auth.listChargers,
            tabName: 'private'
          }
        },
        {
          path: 'closed',
          component: () => import('@/views/chargers/ListTable'),
          meta: {
            auth: Auth.listChargers,
            tabName: 'closed'
          }
        }
      ]
    },
    // 新增
    {
      path: 'new',
      component: () => import('@/views/chargers/New'),
      meta: {
        auth: Auth.createCharger
      }
    },
    // 编辑
    {
      path: ':id/edit',
      component: () => import('@/views/chargers/Edit'),
      meta: {
        auth: Auth.updateCharger
      }
    },
    // 采集器认证记录
    {
      path: ':id/device_authenticated_results',
      component: () => import('@/views/chargers/details/DeviceAuthenticatedResults'),
      meta: {
        auth: Auth.showCharger
      }
    },
    // 详情
    {
      path: ':id',
      component: () => import('@/views/chargers/DetailLayout'),
      meta: {
        auth: Auth.showCharger
      },
      children: [
        // 基本信息
        {
          path: 'detail',
          name: 'chargerDetail',
          component: () => import('@/views/chargers/details/Detail'),
          meta: {
            tabName: 'detail', // 标签页的标签名，用于确认活动的标签页
            auth: Auth.showCharger
          }
        },
        // 订单
        {
          path: 'orders',
          component: () => import('@/views/chargers/details/Orders'),
          meta: {
            tabName: 'orders', // 标签页的标签名，用于确认活动的标签页
            auth: Auth.listOrdersOfCharger
          }
        },
        // 监控
        {
          path: 'monitoring',
          component: () => import('@/views/chargers/details/Monitoring'),
          meta: {
            tabName: 'monitoring', // 标签页的标签名，用于确认活动的标签页
            auth: Auth.showMetricMonitor
          }
        },
        // 报警
        {
          path: 'alarms',
          component: () => import('@/views/chargers/details/Alarms'),
          meta: {
            tabName: 'alarms', // 标签页的标签名，用于确认活动的标签页
            auth: Auth.listAlarmsOfCharger
          }
        },
        // 用户活动
        {
          path: 'station_activities',
          component: () => import('@/views/chargers/details/StationActivities'),
          meta: {
            tabName: 'station_activities', // 标签页的标签名，用于确认活动的标签页
            auth: Auth.listStationActivitiesOfCharger
          }
        },
        // 数据版本日志
        {
          path: 'model_version_log_audits',
          component: () => import('@/views/chargers/details/ModelVersionLogAudits'),
          meta: {
            tabName: 'model_version_log_audits', // 标签页的标签名，用于确认活动的标签页
            auth: Auth.listModelVersionLogAuditsOfCharger
          }
        },
        // 远程控制
        {
          path: 'remote_control',
          component: () => import('@/views/chargers/details/RemoteControl'),
          meta: {
            tabName: 'remote_control', // 标签页的标签名，用于确认活动的标签页
            auth: Auth.showCharger
          }
        },
        // 批量修改属性
        {
          path: 'home/modify',
          component: () => import('@/views/charge_stations/details/Modify'),
          name: 'charge_station_modify',
          meta: {
            auth: Auth.showChargeStation
          }
        }
      ]
    }
  ]
}
